import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

function AbstractPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Abstract</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p class="western"><span lang="en-US">Macroalgae (or seaweeds), are multicellular, photosynthetic algae growing predominantly in marine environment by attaching to suitable substrate. Biomass are composed of structural and storage carbohydrates that have varied multi-functional properties and are exploited in the form of food, medicines, cosmetics and energy. Sustainable utilization of macroalgal biomass for biofuel production has attracted a lot of attention in recent times and has been emerging as potential sustainable alternative to the conventional gasoline-based fuel. This chapter introduces macroalgal structure, habitat, physiology, biochemical composition followed by the global distribution of macroalgal resources and the state-of-the-art technology involved in the conversion of macroalgal biomass for production of biofuel and the constraints encountered in these conversion technologies as well as opportunities to establish a macroalgae based biorefinery. Concluding section discusses, availability of macroalgal resources along East and West coast of India and economic prospects of seaweed for biofuel production.</span></p>
            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default AbstractPage;
